// extracted by mini-css-extract-plugin
export default {"TncLink":"TermsOfUseDescription_TncLink__DUMwM"};